import { useState, useEffect } from 'react';
import Select from 'react-select';

function PackageWarehouseSelect(props) {
  const [selected, setSelected] = useState(null);

  console.log(props?.defaultVal, 'props?.defaultVal');

  // Set default value when props.defaultVal changes
  useEffect(() => {  // No edit for this
    if (props?.defaultVal) {
      setSelected(props?.defaultVal);
    } else {
      setSelected(null);
    }
  }, [props?.defaultVal]);

  const customOption = props?.list?.map(warehouse => {
    return { ...warehouse, label: `${warehouse.warehouse_name}`, value: warehouse.warehouse_id };
  });

  const customStyles = {
    control: base => ({
      ...base,
      height: 42,
      backgroundColor: '#ffffff',
      zIndex: 10,
    }),
    indicatorSeparator: styles => ({ ...styles, display: 'none' }),
    valueContainer: styles => ({
      ...styles,
      backgroundColor: '#ffffff',
      height: 20,
      paddingBottom: '45px',
      marginLeft: '13px',
    }),
    option: styles => ({ ...styles, backgroundColor: 'white', color: 'black' }),
    menuPortal: styles => ({ ...styles, zIndex: 40 }),
  };

  useEffect(() => {
    if (props?.cleared === true) {
      setSelected(null);
    }
  }, [props?.cleared]);

  return (
    <>
      <Select
        menuPlacement="auto"
        placeholder="Select one"
        menuPosition="fixed"
        defaultValue={props.defaultVal || null}
        value={selected}
        onChange={e => {
          setSelected(e);
          props?.onOptionSelect(e);
        }}
        options={customOption}
        styles={customStyles}
        isClearable
      />
    </>
  );
}

export default PackageWarehouseSelect;
